import { StringUnionKeyAsValue } from '../helpers/TypescriptHelpers';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IExplorableItemTypeInfo } from './resourceInfoParts';


/**
 * These are the item types that can be browsed in an Explorer.
 * Includes the "primary" content types (from the exploreContent API) and also non-content
 * entities that can be browsed (e.g. subscriptions, refresh extracts).
 */
export type ExplorableItemType = ExploreContentApi_ContentType
    | 'accelerationTask'
    | 'backgroundJob'
    | 'collection'
    | 'connectedWorkbook'
    | 'connection'
    | 'customView'
    | 'dataalert'
    | 'extractTask'
    | 'flowOutputStepRun'
    | 'workbookAcceleration'
    | 'group'
    | 'recommendedView'
    | 'remoteRefreshSchedule'
    | 'runFlowTask'
    | 'schedule'
    | 'serveruser'
    | 'site'
    | 'siteuser'
    | 'subscription'
    | 'searchuser' // Currently used to display user results in search
  ;

export const ExplorableItemTypeValue: StringUnionKeyAsValue<ExplorableItemType> = {
  project: 'project',
  workbook: 'workbook',
  datasource: 'datasource',
  view: 'view',
  flow: 'flow',
  dataconnection: 'dataconnection',
  dataRole: 'dataRole',
  lens: 'lens',
  databaseWithCrass: 'databaseWithCrass',
  tableWithCrass: 'tableWithCrass',
  database: 'database',
  table: 'table',
  metric: 'metric',
  collection: 'collection',
  publishedConnection: 'publishedConnection',
  accelerationTask: 'accelerationTask',
  backgroundJob: 'backgroundJob',
  connectedWorkbook: 'connectedWorkbook',
  connection: 'connection',
  customView: 'customView',
  dataalert: 'dataalert',
  extractTask: 'extractTask',
  flowOutputStepRun: 'flowOutputStepRun',
  workbookAcceleration: 'workbookAcceleration',
  group: 'group',
  recommendedView: 'recommendedView',
  remoteRefreshSchedule: 'remoteRefreshSchedule',
  runFlowTask: 'runFlowTask',
  schedule: 'schedule',
  serveruser: 'serveruser',
  site: 'site',
  siteuser: 'siteuser',
  subscription: 'subscription',
  searchuser: 'searchuser',
};

/**
 * These are the entity types that have their own landing pages ("space page").
 * These content types and explorable items, so their names should match where possible.
 */
export type SpaceInfoItemType = 'project' | 'schedule' | 'workbook' | 'view' | 'datasource' | 'flow'
  | 'dataRole' | 'lens' | 'group' | 'siteuser'| 'serveruser' | 'metric' | 'collection' | 'publishedConnection';

export const SpaceInfoItemTypeValue: StringUnionKeyAsValue<SpaceInfoItemType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  dataRole: 'dataRole',
  lens: 'lens',
  group: 'group',
  siteuser: 'siteuser',
  serveruser: 'serveruser',
  schedule: 'schedule',
  metric: 'metric',
  collection: 'collection',
  publishedConnection: 'publishedConnection'
};

export function isSpaceInfoItemType(itemType: string): itemType is SpaceInfoItemType {
  return SpaceInfoItemTypeValue.hasOwnProperty(itemType);
}

export function isRecommendationType(itemType: ExplorableItemType): itemType is ExplorableItemType {
  const recommendationTypes = ['recommendedView'];
  return itemType && recommendationTypes.includes(itemType);
}

export function mapRecTypeToBaseType(itemType: string): SpaceInfoItemType{
  if (itemType === 'recommendedView') {
    return 'view';
  }
}

export function getKeyForExplorableItem(item: IExplorableItemTypeInfo): string {
  return `${item.contentType}_${item.id}`;
}
